import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'mr',
    fullName: 'Marathi',
    nativeName: 'मराठी',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid",
    landing_title: "समथिंग अमेझिंग इज कमिंग",
    landing_subtitle: "ArgVoid एक ॲप आणि गेम डेव्हलपमेंट स्टुडिओ आहे. संपर्कात रहा, नवीन गोष्टी लवकरच येत आहेत!",
    select_language: "भाषा निवडा",
    search_placeholder: "भाषा शोधा...",
    terms_title: "सेवा अटी",
    policy_title: "गोपनीयता धोरण",
    cookies_title: "कुकी धोरण",
    terms_content: `
        <strong>1. </strong><br> अटींची स्वीकृती
        ArgVoid मध्ये प्रवेश करून, या सेवा अटी स्वीकारल्या जातात. या अटी मान्य नसल्यास, सेवा वापरली जाऊ नये.<br><br>

        <strong>2. प्लॅटफॉर्म वापर</strong><br>
        ArgVoid आणि त्याचे अनुप्रयोग माहिती आणि सर्जनशील हेतूंसाठी "जसे आहे तसे" प्रदान केले आहेत. सेवा फक्त कायदेशीर हेतूंसाठी वापरली जाणे आवश्यक आहे.<br><br>

        <strong>3. निषिद्ध आचरण</strong><br>
        साइटच्या भेद्यतेचा गैरफायदा घेणे, स्पॅमिंग करणे किंवा पायाभूत सुविधांमध्ये अनधिकृत प्रवेश करण्याचा प्रयत्न करणे कठोरपणे प्रतिबंधित आहे.<br><br>

        <strong>4. अस्वीकरण</strong><br>
        प्लॅटफॉर्म आणि सेवा कोणत्याही सूचनेशिवाय बदलल्या जाऊ शकतात. अपटाइम किंवा सेवेच्या उपलब्धतेबाबत कोणतीही वॉरंटी दिली जात नाही.
    `,
    policy_content: `
        <strong>1. माहिती संकलन</strong><br>
        प्लॅटफॉर्मला यावेळी वापरकर्ता प्रमाणीकरण किंवा खाते तयार करण्याची आवश्यकता नाही. कोणतीही वैयक्तिक ओळख माहिती (जसे की नावे किंवा ईमेल पत्ते) अभ्यागतांकडून सक्रियपणे गोळा केलेली नाही.<br><br>

        <strong>2. वापर डेटा</strong><br>
        साइट रहदारी समजून घेण्यासाठी आणि अनुप्रयोग सुधारण्यासाठी मूलभूत, अनामित विश्लेषणे गोळा केली जाऊ शकतात. हा डेटा वैयक्तिक वापरकर्ता ओळखीशी लिंक केलेला नाही.<br><br>

        <strong>3. तृतीय-पक्ष सेवा</strong><br>
        तृतीय-पक्ष प्रदाते होस्टिंग आणि विश्लेषण सेवांसाठी वापरले जाऊ शकतात. या संबंधित प्रदात्यांच्या गोपनीयता पद्धती त्यांच्या इन्फ्रास्ट्रक्चरवर प्रक्रिया केलेल्या निनावी डेटावर नियंत्रण ठेवतात.<br><br>

        <strong>4. डेटा सुरक्षा</strong><br>
        प्लॅटफॉर्मचे संरक्षण करण्यासाठी वाजवी सुरक्षा उपाय लागू केले जातात. तथापि, इंटरनेटवर प्रसारित करण्याची कोणतीही पद्धत पूर्णपणे सुरक्षित नाही.<br><br>
    `,
    cookies_content: `
        <strong>1. कुकीज आणि स्थानिक स्टोरेज काय आहेत?</strong><br>
        कुकीज आणि ब्राउझर स्थानिक स्टोरेज या सर्व भेटींमध्ये कॉन्फिगरेशन प्राधान्ये लक्षात ठेवण्यासाठी डिव्हाइसवर संग्रहित केलेल्या लहान डेटा फाइल्स आहेत.<br><br>

        <strong>2. Usage Purpose</strong><br>
        ब्राउझर लोकलस्टोरेज कॉन्फिगरेशन सेटिंग्ज जतन करण्यासाठी काटेकोरपणे वापरले जाते, जसे की:<br>
        - भाषा प्राधान्ये<br>
        - वापरकर्ता इंटरफेस कॉन्फिगरेशन (उदा. लेआउट किंवा थीम सेटिंग्ज) <br>
        - तात्पुरता ऍप्लिकेशन cache<br><br>

        <strong>3. ट्रॅकिंग</strong><br> नाही
        कुकीज आणि स्थानिक स्टोरेज जाहिराती किंवा तृतीय-पक्ष ट्रॅकिंग हेतूंसाठी वापरले जात नाहीत. सर्व संग्रहित डेटा प्लॅटफॉर्मच्या मुख्य कार्यक्षमतेसाठी काटेकोरपणे आहे.<br><br>

        <strong>4. Control</strong><br>
        ब्राउझर सेटिंग्जद्वारे ब्राउझर डेटा कधीही साफ केला जाऊ शकतो, ज्यामुळे कोणतीही स्थानिक कॉन्फिगरेशन रीसेट होईल.
    `,
    cookie_consent_text: "तुमचे सत्र सक्रिय ठेवणे, तुमची भाषा प्राधान्ये जतन करणे आणि इतर सानुकूल कॉन्फिगरेशन यांसारख्या वेबसाइटचे कार्य योग्यरित्या होत असल्याची खात्री करण्यासाठी आम्ही मूलभूत कुकीज वापरतो.",
    read_policy: "कुकी धोरण वाचा",
    support_title: "सपोर्टशी संपर्क साधा",
    support_subject_label: "विषय",
    support_message_label: "संदेश",
    support_submit_button: "संदेश पाठवा",
    support_hint: "टीप: हे संदेश पाठवण्यासाठी तुमचा डीफॉल्ट ईमेल अनुप्रयोग उघडेल.",
    support_success_msg: "तुमचे ईमेल ॲप उघडत आहे...",
    support_error_msg: "संदेश पाठवण्यात अयशस्वी. कृपया नंतर पुन्हा प्रयत्न करा.",
    explorer_title: "एक्सप्लोरर",
    history_title: "इतिहास",
    animation_title: "ॲनिमेशन",
    config_title: "कॉन्फिगरेशन",
    tool_mouse: "निवडा (Ctrl+M)",
    tool_brush: "ब्रश (Ctrl+B)",
    tool_brush_mode: "टॉगल मोड (ठोस/साफ)",
    tool_eraser: "इरेजर (Ctrl+E)",
    tool_brush_size: "ब्रश आकार समायोजित करा",
    tool_bucket: "भरा (Ctrl+F)",
    tool_eyedropper: "आयड्रॉपर",
    tool_grid: "ग्रिड (Ctrl+Shift+B)",
    tool_rotate: "फिरवा (Ctrl+Shift+R)",
    tool_flip_h: "फ्लिप H (Ctrl+Shift+H)",
    tool_flip_v: "फ्लिप V (Ctrl+Shift+V)",
    tool_transpose: "ट्रान्सपोज (Ctrl+Shift+T)",
    label_width: "रुंदी",
    label_height: "उंची",
    label_frames: "फ्रेम्सची संख्या",
    label_animation: "ॲनिमेशन शैली",
    label_background_color: "पार्श्वभूमी रंग",
    label_interval: "मध्यांतर",
    tool_anim_config: "ॲनिमेशन कॉन्फिगरेशन",
    label_new_width: "नवीन रुंदी",
    label_new_height: "नवीन उंची",
    label_apply: "अर्ज करा",
    label_colors: "रंग",
    label_size: "आकार",
    label_tolerance: "सहिष्णुता",
    val_horizontal: "क्षैतिज",
    val_vertical: "उभ्या",
    val_sequence: "क्रम",
    val_bounce: "उसळी",
    val_random: "यादृच्छिक",
    val_solid: "घन",
    val_clear: "साफ",
    action_add_sheet: "नवीन पत्रक",
    action_import: "आयात करा",
    action_export: "निर्यात करा",
    action_sort_projects: "क्रमवारी लावा",
    sort_date_old: "सर्वात जुने पहिले",
    sort_date_new: "सर्वात नवीन प्रथम",
    sort_name_az: "नाव (A-Z)",
    sort_name_za: "नाव (Z-A)",
    action_new_sprite: "नवीन स्प्राइट",
    action_new_project: "नवीन प्रकल्प",
    modal_save_all_title: "सर्व बदल जतन करा",
    modal_save_all_desc: "जतन करण्यासाठी मालमत्ता निवडा:",
    modal_save_selected: "निवडलेले जतन करा",
    action_saved: "जतन केले",
    modal_create_sprite_title: "नवीन स्प्राइट तयार करा",
    modal_create_project_title: "नवीन प्रकल्प तयार करा",
    modal_add_sheet_title: "नवीन पत्रक जोडा",
    modal_rename_sheet_title: "पत्रक पुनर्नामित करा",
    modal_rename_sprite_title: "स्प्राइटचे नाव बदला",
    modal_delete_sprite_title: "स्प्राइट हटवा",
    modal_delete_project_title: "प्रकल्प हटवा",
    modal_delete_sheet_title: "पत्रक हटवा",
    placeholder_sprite_name: "नाव",
    placeholder_project_name: "नाव",
    placeholder_sheet_name: "नाव",
    placeholder_new_name: "नवीन नाव",
    action_create: "तयार करा",
    action_add: "ॲड",
    action_rename: "नाव बदला",
    action_duplicate: "डुप्लिकेट",
    action_delete: "हटवा",
    action_cancel: "रद्द करा",
    confirm_delete_sprite: "तुमची खात्री आहे की तुम्ही हा स्प्राइट हटवू इच्छिता?",
    confirm_delete_project: "तुमची खात्री आहे की तुम्ही हा प्रकल्प हटवू इच्छिता? सर्व स्प्राइट्स काढले जातील.",
    confirm_delete_sheet: "तुम्हाला खात्री आहे की तुम्ही हे पत्रक हटवू इच्छिता?",
    err_select_sprite: "कृपया प्रथम स्प्राइट निवडा.",
    err_select_project: "कृपया प्रथम एक प्रकल्प निवडा.",
    err_name_empty: "नाव रिक्त असू शकत नाही.",
    err_sprite_exists: "त्या नावाचा एक स्प्राइट आधीच अस्तित्वात आहे.",
    err_project_exists: "त्या नावाचा प्रकल्प आधीच अस्तित्वात आहे.",
    err_no_content: "जतन करण्यासाठी कोणतीही सामग्री नाही.",
    err_no_changes: "जतन करण्यासाठी कोणतेही बदल नाहीत.",
    err_delete_last_sheet: "शेवटचे पत्रक हटवू शकत नाही.",
    err_extract_frames: "कोणतीही फ्रेम काढता आली नाही.",
    err_indexeddb: "स्थानिकरित्या सेव्ह करण्यात अयशस्वी. तुमचा ब्राउझर IndexedDB ला सपोर्ट करत नाही.",
    msg_upload_success: "अपलोड यशस्वी: {0}",
    msg_upload_failed: "अपलोड अयशस्वी: {0}",
    msg_save_success: "सेव्ह करणे यशस्वी झाले.",
    msg_saving: "सेव्ह करत आहे...",
    msg_multi_save_result: "जतन केलेली {0} मालमत्ता. {1} अपयश.",
    menu_title: "मेनू",
    menu_save: "जतन करा",
    menu_save_all: "सर्व जतन करा",
    menu_support: "सपोर्टशी संपर्क साधा",
    label_local_storage: "स्थानिक स्टोरेज",
    label_sign_in: "साइन इन करा",
    modal_export_title: "स्प्राइट निर्यात करा",
    label_filename: "फाइलनाव",
    label_format: "स्वरूप",
    action_export_confirm: "निर्यात करा",
};

export default translations;
